<template>
<div class="main-content-wrapper">
	<router-view></router-view>
</div>
</template>

<script>

import Blocked from "./Blocked";
import Index from "./Index";
import Meeting from "./Meeting";
import NoMeeting from "./NoMeeting";
import Session from "./Session";
import Transport from "./Transport";
import Welcome from "./Welcome";

export default {
  name: "Container",
  data() {
	  return {
		isBlockedView: false,
		isIndexView: false,
		isNoMeetingView: false,
		isSessionView: false,
		isTransportView: false,
		isWelcomeView: false
	  };
  }
}

</script>

<style scoped>
.color-A {
	/* fallback */
	background-color: #2C2C2C;
	/*height:40px;*/
}

.color-B {
	/* fallback */
	background-color: #666;
	height:40px;
}

.color-C {
	color: #DDD;
	background-color: #DDD;
}

.color-D {
	/* fallback */
	background-color: #FFFFFF;

	/* Safari 4-5, Chrome 1-9 */
	background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#CACACA), to(#FFFFFF));

	/* Safari 5.1, Chrome 10+ */
	background: -webkit-linear-gradient(top, #FFFFFF, #CACACA);

	/* Firefox 3.6+ */
	background: -moz-linear-gradient(top, #FFFFFF, #CACACA);

	/* IE 10 */
	background: -ms-linear-gradient(top, #FFFFFF, #CACACA);

	/* Opera 11.10+ */
	background: -o-linear-gradient(top, #FFFFFF, #CACACA);
}

.color-E {
	/* fallback */
	background-color: #000;
}

.color-F {
	/* fallback */
	background-color: #E58C26;

	/* Safari 4-5, Chrome 1-9 */
	background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#F67C21), to(#FABE41));

	/* Safari 5.1, Chrome 10+ */
	background: -webkit-linear-gradient(top, #FABE41, #F67C21);

	/* Firefox 3.6+ */
	background: -moz-linear-gradient(top, #FABE41, #F67C21);

	/* IE 10 */
	background: -ms-linear-gradient(top, #FABE41, #F67C21);

	/* Opera 11.10+ */
	background: -o-linear-gradient(top, #FABE41, #F67C21);
	height:40px;
	-webkit-border-radius: 20px;
    border-radius: 20px;
}

/** Inject desktop.css */

body {
	font-family: Arial, sans-serif;
	color: #000;
	font-size: 12px;
}

.non-mobile {
	display: block;
}

.mobile {
	display: none;
}

.methods {
	float:left;
	width:100%;	
}

.spacer {
	float:left;
	width:100%;
	height:15px;
}

.div-field {
	float:left;
	width:250px;
}

.div-fieldLabel {
	width:100px;
	float:left;
}

.div-upgrade-selector {
	display:none;
	width:100%;
	float:left;
}

input[type="text"] {
	font-family: Arial, sans-serif;
	font-size: 11px;
	color: #000;
	width: 150px;
}

#button-connect {
	padding:0;
	border:1px #000 solid;
	height:36px;
	cursor:pointer;
}

a { /* Sets attributes for the <a> class */
	color: black;	
	text-decoration: none;
}


#div-connectWithUs { /* Sets attribute for the connect-with-us.jpg */
	
}


#div-mainContainer { /* Sets attributes for the #container */
	width: 1011px;
	margin: auto;
}


#div-weatherContainer { /* Sets attributes for the area underneath #purple */
	width: 409px;
	background-color: #DDD;
	float:left;
	padding-top:10px;
	padding-bottom:10px;
}


#div-barGrey { /* Sets attributes for the area above #connect */
	width: 601px;
	height: 5px;
	background-color: #DDD;
}


.div-row { /* Sets attributes for the #header */
	width: 100%;
	float:left;
}


.div-left { /* Sets attribute for the innflux-logo.gif */
	float: left;
	width: 409px;
}

.div-right { /* Sets attribute for the hotel-logo.jpg */
	float: right;
	width: 601px;
}

#div-loginContainer { /* Sets attribute for the login-area-bg.jpg */
	float: left;
	width: 389px;
	padding-top: 15px;
	padding-bottom: 15px;
	padding-left: 10px;
	padding-right: 10px;
}


#div-barPurple { /* Sets attributes for the area above #purple */
	width: 409px;
	height: 5px;
	background-color: #006;
}


#sponsor-1 { /* Sets attribute for the first text area below connect-with-us.jpg */
	float:left;	
}


#sponsor-2{ /* Sets attribute for the second text area below connect-with-us.jpg */
	float:right;
}

/** inject font.css */
.font-A {
	font-family: "Arial Regular", Arial;
	font-size: 0.750em;
	text-align: right;
	color: #FFF;
}

.font-B {
	font-family: "Arial Bold", Arial;
	font-size: 1.50em;
	text-align: right;
	color: #FFF;
}

.font-C {
	font-family: "Arial Bold", Arial;
	font-size: 0.875em;
	text-align: right;
	color: #FFF;
}

.font-D {
	font-family: "Arial Regular", Arial;
	font-size: 1.875em;
	text-align: center;
	color: #FFF;
}

.font-E {
	font-family: "Arial Narrow", Arial;
	font-size: 1.250em;
	text-align: center;
	color: #FFF;
}

.font-F {
	font-family: "Arial Narrow", Arial;
	font-size: 0.938em;
	text-align: center;
	color: #666;
}

.font-G {
	font-family: "Arial Narrow", Arial;
	font-size: 1.125em;
	text-align: center;
	color: #2C2C2C;
}

.font-H {
	font-family: "Arial Narrow", Arial;
	font-size: 1.125em;
	text-align: center;
	color: #2C2C2C;
}

.font-I {
	font-family: "Arial Narrow", Arial;
	font-size: 1.313em;
	text-align: center;
	color: #2C2C2C;
}

.font-J {
	font-family: "Arial Narrow", Arial;
	font-size: 1.313em;
	text-align: center;
	color: #2C2C2C;
}

.font-K {
	font-family: "Arial Narrow", Arial;
	font-size: 1.125em;
	color: #666;
}

.font-L {
	font-family: "Arial Regular", Arial;
	font-size: 0.875em;
	color: #333;
}

.font-M {
	font-family: "Arial Narrow Regular", Arial;
	font-size: 1.50em;
	text-align: center;
	color: #FFF;
}

.font-N {
	font-family: "Arial Narrow Bold", Arial;
	font-size: 1.250em;
	text-align: center;
	color: #FFF;
	text-shadow: 1px 1px 1px #000;
	filter: dropshadow(color=#000, offx=1, offy=1);
}

.font-N a {
	text-decoration: underline;
}

.font-O {
	font-family: "Arial Regular", Arial;
	line-height: 1.250em;
	font-size: 0.625em;
	text-align: center;
	color: #FFF;
}

.font-O a {
	text-decoration: underline;
	color: #FFF;
}

.font-B-container {
	font-family: "Arial Bold", Arial;
	font-size: 1.125em;
	text-align: center;
	color: #000;
}

.font-C-container {
	font-family: "Arial Regular", Arial;
	font-size: 0.875em;
	text-align: center;
	color: #666;
}

.font-D-container {
	font-family: "Arial Regular", Arial;
	font-size: 0.875em;
	text-align: center;
	color: #000;
}

.font-F-container {
	font-family: "Arial Regular", Arial;
	font-size: 0.750em;
	text-align: center;
	color: #0000CC;
}

.font-G-container {
	font-family: "Arial Regular", Arial;
	font-size: 0.750em;
	text-align: center;
	color: #666;
}

.font-H-container {
	font-family: "Arial Regular", Arial;
	font-size: 0.875em;
	text-align: center;
	color: #000;
}

.font-J-container {
	font-family: "Arial Bold", Arial;
	font-size: 1.125em;
	text-align: center;
	color: #000;
}

/**
* inject style.css 
*/
html {
	height:100%;
}

body {
	color:#FFF;
	font-family:Georgia, "Times New Roman", Times, serif;
	font-size:100%;

	background-color: #CCCCCC;

	height:100%;
	background-position: center bottom;
	background-repeat: no-repeat;
}

body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, input, textarea, p, blockquote, th, td {
	padding:0px;
	margin:0px;
}

a {
	color: #00F;
}

.mobile {
	display:none;
}
.tablet {
	display:none;
}

.non-mobile {
	display:block;
}

#div-header {
	height:100px;
	width:100%;
	max-width:1400px;
	margin:0 auto;
}

#div-header img {
	float:left;
	/*padding:25px;*/
}

#div-address {
	float:right;
	padding:30px;
}

#div-footer {
	min-height:70px;
	width:100%;
	margin:0 auto;
}

#div-faded-background {
	top:0px;
	position:absolute;
	z-index:1020;
	background-color:#000000;
	zoom: 1;
	filter: alpha(opacity=70);
	opacity: 0.7;
	display:none;
	float:none;
}

#div-trouble-container {
	z-index:1030;
	position:absolute;
	width:100%;
	max-width:500px;
	padding:30px;
	display:none;
	background-color:#FFF;
}

#div-trouble-container a {
	color:#333333;
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.75em;
	text-decoration:underline;
	padding-right:30px;
}

#div-disclaimer-container {
	z-index:1030;
	position:absolute;
	height:100%;
	max-height:500px;
	width:100%;
	max-width:500px;
	display:none;
	background-color:#FFF;
}

#div-disclaimer-container a {
	color:#333333;
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.75em;
	text-decoration:underline;
	padding-right:30px;
}

#div-disclaimer-container iframe {
	height:100%;
	max-height:449px;
	width:100%;
	max-width:500px;
}

.div-standard-container {
	display:block;

	z-index:1000;
	width:80%;
	max-width:570px;
	min-width:300px;

	margin-left:auto;
	margin-right:auto;
	overflow:hidden;
	position:relative;
}

.div-standard-container > div {
	padding: 5px;
	float: none;
}

#div-highspeed-container {
	z-index:1000;
	width:80%;
	max-width:500px;
	display:block;
	background-color:#FFF;
	padding:20px;
	margin-left:auto;
	margin-right:auto;
	overflow:hidden;
}

#div-enhanced-paid-tier-container {
	z-index:1000;
	width:80%;
	max-width:500px;
	display:block;
	background-color:#FFF;
	padding:20px;
	margin-left:auto;
	margin-right:auto;
	overflow:hidden;
}

#div-error-container {
	z-index:1000;
	width:80%;
	max-width:500px;
	display:block;
	background-color:#FFF;
	padding:30px;
	border:1px solid #9D102D;
	margin-left:auto;
	margin-right:auto;
	overflow:hidden;
}

.error-message {
	border:1px solid #9D102D;
	padding:10px;
	width:80%;
}


.headline {
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.800em;
	font-weight:bold;
	color:#9D102D;
}

.error-body {
	font-family:Arial, Helvetica, sans-serif;
	font-size:1em;
	color:#9D102D;
}

.info-message {
    /*border:1px solid #222;*/
    padding:10px;
    width:80%;
}


.info-headline {
    font-family:Arial, Helvetica, sans-serif;
    font-size:1.5em !important;
    font-weight:bold !important;
    color:#222;
}

.info-body {
    font-family:Arial, Helvetica, sans-serif;
    font-size:1em !important;
    line-height: 22px !important;
    color:#222 !important;
}

.subhead {
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.875em;
	font-weight:bold;
	color:#333333;
}

.body-copy {
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.75em;
	color:#333333;
}

.input-field {
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.875em;
	color:#333333;
	height:30px;
	border:1px solid #333333;
	padding-left:5px;
	padding-right:5px;
}

.input-field-label {
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.625em;
	font-weight:bold;
	color:#333333;
	padding-bottom:3px;
}

.form-spacer {
	height:12px;
}

.links {
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.75em;
	text-decoration:underline;
	font-weight:normal;
	color:#333333;
}

.button-0 {
	width:250px;
	min-width:250px;
	border-style: none;
}

.div-lightbox-container {
	z-index:1030;
	position:absolute;
	width:100%;
	max-width:500px;
	display:none;
	background-color:#FFF;
}

.div-lightbox-container a {
	color:#333333;
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.75em;
	text-decoration:underline;
}


</style>